export default __webpack_public_path__ + "static/media/039-knee.de20b8d0.svg";